import React from 'react'

const Separator = () => <div className='separator'>* * *</div>

export default Separator
